<script lang="ts">
    import type { TBlock } from '$lib/services/blocks/types';
    import PageBuilderReferences from './PageBuilderReferences.svelte';
    import MfeComponentDebugger from './MfeComponentDebugger.svelte';

    export let blockData: TBlock[];
    export let cssReferences: string[];
    export let scriptReferences: string[];
    export let debug: boolean;
</script>

<PageBuilderReferences styles={cssReferences} scripts={scriptReferences} />
{#each blockData as { module, hydrate, payload, markup, mfe, legacyParams }}
    <MfeComponentDebugger {mfe} {module} {debug}>
        {@html `
            <${mfe}
                component="${module}"
                params="${payload}"
                hydrate="${hydrate}"
                ${legacyParams}
            >
                ${markup}
            </${mfe}>
        `}
    </MfeComponentDebugger>
{/each}
